import { mapGetters } from 'vuex';

export default {

    computed: {
		...mapGetters([
			'errorFields'
        ]),
        errorBName() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BName')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
		errorBEmail() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BEmail')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorBPhone() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BPhone')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorBAddress() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BAddress')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorBCity() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BCity')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorBZip() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BZip')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorBState() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BState')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorBCountry() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'BCountry')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
		errorSName() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SName')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
		errorSEmail() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SEmail')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorSPhone() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SPhone')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorSAddress() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SAddress')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorSCity() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SCity')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorSZip() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SZip')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorSState() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SState')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        errorSCountry() {
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'SCountry')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
        invalidPO(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'PO')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}

			return invalid;
		},
		invalidCC_MO(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_Mo')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_Yr(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_Year')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_CVV(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_CVV')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_Zip(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_Zip')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_Name(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_Name')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_Address(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_Address')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_City(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_City')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_State(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_State')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidCC_Country(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'CC_Country')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidPassword(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'PWord')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
		invalidRePassword(){
			// let className = '';
			let invalid = this.errorFields.find((item) => {
				return (item.input === 'RePWord')
			});

			if(invalid != undefined){
				invalid.className = 'is-invalid';
			}else{
				invalid = {'className' : '', 'message' : ''};
			}
			
			return invalid;
		},
    }
}